import React from 'react';

import { cn } from '../../utils/cn';

interface InputProps extends React.HTMLProps<HTMLInputElement> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = React.forwardRef<HTMLInputElement, Omit<InputProps, 'label'>>(
  ({ className, ...props }, ref) => {
    const { type, placeholder, value, onChange, children } = props;
    return (
      <input
        className={cn(
          `tw-flex tw-h-10 tw-w-full tw-rounded-md tw-border tw-border-slate-300 tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-400 focus:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 dark:tw-border-slate-700 dark:tw-text-slate-50 dark:focus:tw-ring-slate-400 dark:focus:tw-ring-offset-slate-900`,
          className,
        )}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          }
        }}
        onBlur={onChange}
        ref={ref}
        autoComplete="off"
        {...props}
      >
        {children}
      </input>
    );
  },
);

Input.displayName = 'Input';

export { Input };
